var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.463 21.6929C12.3259 21.6361 12.2088 21.54 12.1264 21.4166C12.044 21.2933 12 21.1483 12 21V17.25H4.5C4.10231 17.2495 3.72105 17.0913 3.43984 16.8101C3.15864 16.5289 3.00045 16.1477 3 15.75V8.24999C3.00045 7.8523 3.15864 7.47103 3.43984 7.18983C3.72105 6.90862 4.10231 6.75044 4.5 6.74998H12V2.99998C12 2.85165 12.044 2.70665 12.1264 2.58332C12.2088 2.45999 12.326 2.36387 12.463 2.3071C12.6001 2.25033 12.7509 2.23547 12.8963 2.2644C13.0418 2.29333 13.1755 2.36475 13.2804 2.46962L22.2804 11.4696C22.421 11.6103 22.5 11.8011 22.5 12C22.5 12.1989 22.421 12.3897 22.2804 12.5304L13.2804 21.5304C13.1755 21.6352 13.0418 21.7066 12.8963 21.7355C12.7508 21.7645 12.6 21.7496 12.463 21.6929Z",
    fill: "#C3C3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.faecff98051e0991f8e92b8fd61ca790.svg";
export { ForwardRef as ReactComponent };